export enum EOrderAsLastTimeState {
  INFO_PAGE,
  ACTION_PAGE,
  ADDITIONAL_ACTION_PAGE,
  ERROR,
}
